import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link as Link2 } from "react-router-dom";

import Logo from "../assets/images/logo-light.svg";

export default function Footer2() {
  return (
    <footer className="bg-footer">
      <Container>
        <Row>
          <div className="col-12">
            <div className="footer-py-60">
              <Row>
                <div className="col-lg-4 col-12 mb-lg-0 mb-md-4 pb-lg-0 pb-md-2">
                  <Link2 to="/" className="logo-footer">
                    <img src={Logo} height="24" alt="" />
                  </Link2>
                  <p className="mt-4 mb-0">
                    It's a 'new mantra' of automation, machine learning, Al, and
                    analytics solutions. We will accelerate your organization's
                    evolution as the 'Citizen Data Scientist' community.
                  </p>

                  {/* <div className="pt-3 d-flex align-items-center">
                    <i className="uil uil-clock text-numantra-primary me-2 fs-1"></i>
                    <div className="content">
                      <p className="mb-1 text-foot">Mon - Sat :</p>
                      <span className="text-light">10:00 AM To 07:30 PM</span>
                    </div>
                  </div> */}
                </div>

                <div className="col-lg-4 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <h5 className="footer-head">Get In Touch</h5>

                  <div className="mt-4">
                    <div className="mb-3">
                      <strong>USA</strong>
                      <br />
                      20600 Chagrin Blvd, Shaker Heights, OH 44122
                    </div>
                    <div className="mb-3">
                      <strong>India</strong>
                      <br />
                      301-2/510-11 Gateway Plaza, Hiranandani Gardens Powai,
                      Mumbai, MH 400076
                    </div>
                  </div>
                  <ul className="list-unstyled footer-list mt-3">
                    {/* <li>
                      Phone:{" "}
                      <a href="tel:+152534-468-854" className="text-light">
                        +152 534-468-854
                      </a>
                    </li> */}
                    <li>
                      Email:{" "}
                      <a
                        href="mailto:bdm@numantratech.ai"
                        className="text-light"
                      >
                        bdm@numantratech.ai
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="col-lg-4 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  {/* <h5 className="footer-head">Get In Touch</h5> */}
                  <h5 className="footer-head-hidden">X</h5>

                  <div className="mt-4">
                    <div className="mb-3">
                      <strong>Switzerland</strong>
                      <br />
                      Bahnhofstrasse 10, 8001 Zurich
                    </div>
                    <div className="mb-3">
                      <strong>Finland</strong>
                      <br />
                      Michelininkatu 1A, 00180 Helsinki
                    </div>
                  </div>
                </div>
              </Row>
            </div>
          </div>
        </Row>
      </Container>

      <div className="footer-py-30 footer-bar">
        <div className="container text-center">
          <Row className="align-items-center justify-content-center">
            <Col sm={8}>
              <div className="text-sm-start">
                <p className="mb-0">
                  © {new Date().getFullYear()} Numantra Technologies. All rights
                  reserved.
                </p>
                <p>Version: 2.0.1</p>
              </div>
            </Col>

            <div className="col-sm-4 mt-4 mt-sm-0">
              <ul className="list-unstyled social-icon text-sm-end foot-social-icon mb-0">
                <li className="list-inline-item ms-1">
                  <Link2
                    to="https://www.linkedin.com/company/numantra-technologies-inc/"
                    no
                    className="rounded"
                    target="_blank"
                  >
                    <i className="uil uil-linkedin" title="Linkedin"></i>
                  </Link2>
                </li>
                {/* <li className="list-inline-item ms-1">
                  <Link2 to="#" className="rounded">
                    <i
                      className="uil uil-facebook-f align-middle"
                      title="facebook"
                    ></i>
                  </Link2>
                </li> */}
                <li className="list-inline-item ms-1">
                  <Link2 to="#" className="rounded">
                    <i
                      className="uil uil-twitter align-middle"
                      title="twitter"
                    ></i>
                  </Link2>
                </li>
                <li className="list-inline-item ms-1">
                  <Link2
                    to="mailto:bdm@numantratech.ai"
                    className="rounded"
                    target="_blank"
                  >
                    <i
                      className="uil uil-envelope align-middle"
                      title="email"
                    ></i>
                  </Link2>
                </li>
              </ul>
            </div>
          </Row>
        </div>
      </div>
    </footer>
  );
}
